import { motion } from "framer-motion"

import { useAnimation } from "utils/useAnimation"

import { Section, Title, WysiwygText } from "components/shared"

import { TreeBackground } from "assets/icons"

const Overview = ({ id, overview, whoDescription, benefits, candidates }) => {
  const { variants } = useAnimation()
  return (
    <Section
      id={id}
      contentClassName="flex flex-col lg:flex-row gap-16 sm:gap-24 lg:gap-60"
      className="!pb-20 lg:!pb-28"
      padding="md"
      animate
    >
      <div className="flex-1 space-y-5">
        <Title title="What is it?" pretitle="Overview" size="sm" animate />
        <WysiwygText text={overview} animate />
        {benefits?.length > 0 && (
          <ul className="!mt-8 check-bullets">
            {benefits?.map((benefit, index) => (
              <motion.li key={index} variants={variants}>
                {benefit.benefit}
              </motion.li>
            ))}
          </ul>
        )}
      </div>
      <div className="flex-1 space-y-3 lg:mt-48">
        <Title title="Who’s it for?" pretitle="Candidates" size="sm" animate />
        <WysiwygText text={whoDescription} animate />
        {candidates?.length > 0 && (
          <ul className="!mt-8 check-bullets">
            {candidates?.map((candidate, index) => (
              <motion.li key={index} variants={variants}>
                {candidate.candidate}
              </motion.li>
            ))}
          </ul>
        )}
      </div>
      <TreeBackground className="!ml-0 absolute top-[-100px] right-[-350px] z-10" />
      <TreeBackground className="!ml-0 absolute bottom-[-350px] left-[-450px] z-10" />
    </Section>
  )
}

export default Overview
